var conf = {
    '10x10':{},
    '8x8'  :{},
    '8x8_italian'  :{},
    '12x12':{}
};

// The greatest square number
conf['10x10']['SQ_MAX_NUM'] = 50;
conf['8x8']['SQ_MAX_NUM']   = 32;
conf['8x8_italian']['SQ_MAX_NUM']   = 32;
conf['12x12']['SQ_MAX_NUM'] = 72;

// Number of active square per line
conf['10x10']['SQ_ACTIVE_PER_LINE'] = 5;
conf['8x8']['SQ_ACTIVE_PER_LINE']   = 4;
conf['8x8_italian']['SQ_ACTIVE_PER_LINE']   = 4;
conf['12x12']['SQ_ACTIVE_PER_LINE'] = 6;

// Black initial position
conf['10x10']['B_POSITION'] = [1, 20];
conf['8x8']['B_POSITION']   = [1, 12];
conf['8x8_italian']['B_POSITION']   = [1, 12];
conf['12x12']['B_POSITION'] = [1, 30];

// White initial position
conf['10x10']['W_POSITION'] = [31, 50];
conf['8x8']['W_POSITION']   = [21, 32];
conf['8x8_italian']['W_POSITION']   = [21, 32];
conf['12x12']['W_POSITION'] = [43, 72];

// White pieces are crowned on this interval
conf['10x10']['W_CROWNED'] = [1, 5];
conf['8x8']['W_CROWNED']   = [1, 4];
conf['8x8_italian']['W_CROWNED']   = [1, 4];
conf['12x12']['W_CROWNED'] = [1, 12];

// Black pieces are crowned on this interval
conf['10x10']['B_CROWNED'] = [46, 50];
conf['8x8']['B_CROWNED']   = [29, 32];
conf['8x8_italian']['B_CROWNED']   = [29, 32];
conf['12x12']['B_CROWNED'] = [61, 72]


/** List of diagonal parallel to the "Great Diagonal" */
conf['10x10']['DIAGONALS_GD'] = [
    [  6,  1 ], 
    [ 16, 11,  7,  2 ], 
    [ 26, 21, 17, 12,  8,  3 ], 
    [ 36, 31, 27, 22, 18, 13,  9,  4 ], 
    [ 46, 41, 37, 32, 28, 23, 19, 14, 10, 5 ],
    [ 47, 42, 38, 33, 29, 24, 20, 15 ], 
    [ 48, 43, 39, 34, 30, 25 ], 
    [ 49, 44, 40, 35 ], 
    [ 50, 45 ] 
];

conf['8x8']['DIAGONALS_GD'] = [
    [  5,  1 ], 
    [ 13,  9,  6,  2 ], 
    [ 21, 17, 14, 10,  7,  3 ], 
    [ 29, 25, 22, 18, 15, 11, 8, 4 ], 
    [ 30, 26, 23, 19, 16, 12 ],
    [ 31, 27, 24, 20 ], 
    [ 32, 28 ] 
];

conf['8x8_italian']['DIAGONALS_GD'] = [
    [ 1],
    [ 9, 5, 2 ], 
    [ 17, 13, 10, 6, 3 ], 
    [ 25, 21, 18, 14, 11, 7, 4 ], 
    [ 29, 26, 22, 19, 15, 12, 8 ], 
    [ 30, 27, 23, 20, 16 ],
    [ 31, 28, 24 ], 
    [ 32]
];


conf['12x12']['DIAGONALS_GD'] = [
    [ 7,  1 ], 
    [ 19, 13,  8,  2 ], 
    [ 31, 25, 20, 14,  9,  3 ], 
    [ 43, 37, 32, 26, 21, 15, 10,  4 ], 
    [ 55, 49, 44, 38, 33, 27, 22, 16, 11,  5 ],
    [ 67, 61, 56, 50, 45, 39, 34, 28, 23, 17, 12, 6 ], 
    [ 68, 62, 57, 51, 46, 40, 35, 29, 24, 18 ], 
    [ 69, 63, 58, 52, 47, 41, 36, 30 ], 
    [ 70, 64, 59, 53, 48, 42 ], 
    [ 71, 65, 60, 54 ], 
    [ 72, 66 ] 
];


/** List of diagonal parallel to the "Tric Trac" */
conf['10x10']['DIAGONALS_TT'] = [ 
    [  5 ], 
    [ 15, 10,  4 ], 
    [ 25, 20, 14,  9,  3 ], 
    [ 35, 30, 24, 19, 13,  8,  2 ], 
    [ 45, 40, 34, 29, 23, 18, 12,  7, 1 ], 
    [ 50, 44, 39, 33, 28, 22, 17, 11, 6 ],
    [ 49, 43, 38, 32, 27, 21, 16 ], 
    [ 48, 42, 37, 31, 26 ], 
    [ 47, 41, 36 ], 
    [ 46 ] 
];

conf['8x8']['DIAGONALS_TT'] = [ 
    [  4 ], 
    [ 12,  8,  3 ], 
    [ 20, 16, 11,  7,  2 ], 
    [ 28, 24, 19, 15, 10, 6, 1 ], 
    [ 32, 27, 23, 18, 14, 9, 5 ], 
    [ 31, 26, 22, 17, 13 ],
    [ 30, 25, 21 ], 
    [ 29 ]
];

conf['8x8_italian']['DIAGONALS_TT'] = [ 
    [ 29, 25 ], 
    [ 30, 26, 21, 17 ], 
    [ 31, 27, 22, 18, 13, 9 ], 
    [ 32, 28, 23, 19, 14, 10, 5, 1 ], 
    [ 24, 20, 15, 11, 6,  2 ], 
    [ 16, 12, 7, 3, ],
    [ 8, 4 ], 
];

conf['12x12']['DIAGONALS_TT'] = [ 
    [  6 ], 
    [ 18, 12,  5 ], 
    [ 30, 24, 17, 11,  4 ], 
    [ 42, 36, 29, 23, 16, 10,  3 ], 
    [ 54, 48, 41, 35, 28, 22, 15,  9,  2 ], 
    [ 66, 60, 53, 47, 40, 34, 27, 21, 14,  8, 1 ],
    [ 72, 65, 59, 52, 46, 39, 33, 26, 20, 13, 7 ],
    [ 71, 64, 58, 51, 45, 38, 32, 25, 19 ],
    [ 70, 63, 57, 50, 44, 37, 31 ],
    [ 69, 62, 56, 49, 43 ],
    [ 68, 61, 55 ],
    [ 67 ]
];


exports.Conf = conf;



// WEBPACK FOOTER //
// ./src/board/utils/conf.js